<div class="row">
  <div class="col-12">
    <div class="content-header">Center Aligned Vertical Timeline</div>
    <p class="content-sub-header mb-1">This vertical timeline contain posts with photos, statistics and carousel to make the timeline more effective.</p>
  </div>
</div>
<h2 class="text-center py-4">Company Timeline</h2>
<!--Vertical Timeline Starts-->
<section id="vertical-timeline-center" class="timeline-center timeline-wrapper col-sm-10 col-12 offset-sm-1">
  <ul class="timeline">
    <li class="timeline-line mt-4"></li>
      <li class="timeline-group">
        <h5><span class="badge badge-primary cursor-default">Today</span></h5>
      </li>
  </ul>
  <ul class="timeline">
    <li class="timeline-line"></li>
    <li class="timeline-item">
      <div class="timeline-badge">
        <span class="bg-primary bg-lighten-4" data-toggle="tooltip" placement="right" ngbTooltip="Portfolio project work">
          <i class="ft-award primary"></i>
        </span>
      </div>
      <div class="timeline-card card shadow-z-1">
        <div class="card-header">
          <img class="img-fluid" src="assets/img/banner/banner-16.jpg" alt="Timeline Image 1">
        </div>
        <div class="card-content">
          <div class="card-body">
            <h4 class="card-title mb-0">Portfolio Project Work</h4>
            <div class="card-subtitle text-muted mt-0">
              <span class="font-small-3">5 hours ago</span>
            </div>
            <hr class="mt-0 mb-2">
            <p class="m-0">Nullam facilisis fermentum aliquam. Suspendisse ornare dolor vitae libero hendrerit auctor lacinia a ligula. Curabitur elit tellus, porta ut orci sed, fermentum bibendum nisi.</p>
            <hr class="my-2">
            <div class="list-inline">
              <span class="badge bg-light-primary mb-1 mr-1"><i class="ft-thumbs-up mr-1"></i>Like</span>
              <span class="badge bg-light-primary mb-1 mr-1"><i class="ft-message-square mr-1"></i>Comment</span>
              <span class="badge bg-light-primary mb-1"><i class="ft-share-2 mr-1"></i>Share</span>
            </div>
          </div>
        </div>
      </div>
    </li>

    <li class="timeline-item mt-5">
      <div class="timeline-badge">
        <span class="avatar" data-toggle="tooltip" placement="left" ngbTooltip="Eu pid nunc urna integer">
          <img src="assets/MeanderLIVE-icon.png" class="avatar" alt="avatar" width="40">
        </span>
      </div>
      <div class="timeline-card card shadow-z-1">
        <div class="card-body">
          <p><span class="float-right cursor-pointer"><i class="ft-more-horizontal"></i></span>Website Traffic</p>
          <h3>392,912<small class="success font-small-3 ml-3"><i class="ft-arrow-up-right mr-1"></i>-0.42%</small></h3>
          <div class="progress my-3">
            <div class="progress-bar bg-primary" role="progressbar" style="width: 34%" aria-valuenow="34" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-primary bg-lighten-1" role="progressbar" style="width: 29%" aria-valuenow="29" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-primary bg-lighten-2" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-primary bg-lighten-3" role="progressbar" style="width: 12%" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <ul class="list-unstyled">
            <li class="mb-1">
              <span class="primary mr-1">
                <i class="fa fa-circle font-small-1"></i>
              </span>
              <span>Direct Visits</span>
              <span class="float-right text-bold-600">33.94%</span>
            </li>
            <li class="mb-1">
              <span class="primary lighten-1 mr-1">
                <i class="fa fa-circle font-small-1"></i>
              </span>
              <span>Refferals Websites</span>
              <span class="float-right text-bold-600">28.72%</span>
            </li>
            <li class="mb-1">
              <span class="primary lighten-2 mr-1">
                <i class="fa fa-circle font-small-1"></i>
              </span>
              <span>Social Networks</span>
              <span class="float-right text-bold-600">25.28%</span>
            </li>
            <li>
              <span class="primary lighten-3 mr-1">
                <i class="fa fa-circle font-small-1"></i>
              </span>
              <span>Organic Search</span>
              <span class="float-right text-bold-600">12.06%</span>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>

  <!-- Last Week -->
  <ul class="timeline">
    <li class="timeline-line"></li>
    <li class="timeline-group">
      <h5><span class="badge badge-primary cursor-default">Last Week</span></h5>
    </li>
  </ul>
  <ul class="timeline">
    <li class="timeline-line"></li>
    <li class="timeline-item">
      <div class="timeline-badge">
        <span class="avatar" data-toggle="tooltip" placement="left" ngbTooltip="Eu pid nunc urna integer">
          <img src="assets/img/portrait/small/avatar-s-8.png" class="avatar" alt="avatar" width="40">
        </span>
      </div>
      <div class="timeline-card card shadow-z-1 overflow-hidden">
        <div class="card-content">
          <div class="card-img">
            <ngb-carousel>
              <ng-template ngbSlide>
                <img src="assets/img/banner/banner-9.jpg" class="d-block w-100" alt="First slide">
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/banner/banner-2.jpg" class="d-block w-100" alt="Second slide">
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/banner/banner-5.jpg" class="d-block w-100" alt="Third slide">
              </ng-template>
            </ngb-carousel>
          </div>
          <div class="card-body">
            <h4 class="card-title">Office Photography</h4>
            <p class="card-text">Sweet halvah dragée jelly-o halvah carrot cake oat cake. Donut jujubes jelly chocolate
              cake.</p>
            <button type="button" class="btn bg-light-info">Show More</button>
          </div>
        </div>
      </div>
    </li>

    <li class="timeline-item mt-5">
      <div class="timeline-badge">
        <span class="avatar" data-toggle="tooltip" placement="left" ngbTooltip="Eu pid nunc urna integer">
          <img src="assets/img/portrait/small/avatar-s-11.png" class="avatar" alt="avatar" width="40">
        </span>
      </div>
      <div class="timeline-card card bg-transparent shadow-none">
        <div class="card-body pt-1 pb-0">
          <h4 class="card-title mb-3 d-flex align-items-center"><i class="ft-briefcase mr-2 font-large-1"></i>Top notch work</h4>
          <p><strong>December</strong> Acquired ‘A’ rating for fair trade compliance (fair trade commission)</p>
          <p><strong>October</strong> Received ‘Telecommunications / IT Sector’ CRM</p>
          <p><strong>May</strong> Commendation from Minister of Information and Communication</p>
          <p><strong>03</strong> Established a local subsidiary</p>
        </div>
      </div>
    </li>
  </ul>


  <!-- 2016 -->
  <ul class="timeline">
    <li class="timeline-line"></li>
    <li class="timeline-group">
      <h5><span class="badge badge-primary cursor-default">2016</span></h5>
    </li>
  </ul>
  <ul class="timeline">
    <li class="timeline-line"></li>

    <li class="timeline-item">
      <div class="timeline-badge">
        <span class="avatar" data-toggle="tooltip" placement="right" ngbTooltip="Eu pid nunc urna integer">
          <img src="assets/img/portrait/small/avatar-s-5.png" class="avatar" alt="avatar" width="40">
        </span>
      </div>
      <div class="timeline-card card shadow-z-1 card-inverse">
        <img class="card-img img-fluid" src="assets/img/photos/08.jpg" alt="Card image">
      </div>
    </li>

    <li class="timeline-item mt-5">
      <div class="timeline-badge">
        <span class="bg-primary bg-lighten-4" data-toggle="tooltip" placement="left" ngbTooltip="Nullam facilisis fermentum">
          <i class="ft-command primary"></i>
        </span>
      </div>
      <div class="timeline-card card shadow-z-1">
        <div class="card-header">
          <h4 class="mb-0 card-title">
            <span class="cursor-pointer">Sofia Orav</span>
          </h4>
          <div class="card-subtitle text-muted mt-0">
            <span class="font-small-3">18 June, 2016 at 4.50 P.M</span>
          </div>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ul class="list-group icheck-task">
              <li class="list-group-item">
                <div class="checkbox">
                  <input type="checkbox" id="1st-item" checked>
                  <label for="1st-item"><span>Cras justo odio</span></label>
                </div>
              </li>
              <li class="list-group-item">
                <div class="checkbox">
                  <input type="checkbox" id="2nd-item" checked>
                  <label for="2nd-item"><span>checked Dapibus ac facilisis in</span></label>
                </div>
              </li>
              <li class="list-group-item">
                <div class="checkbox">
                  <input type="checkbox" id="3rd-item" checked>
                  <label for="3rd-item"><span>Morbi leo risus</span></label>
                </div>
              </li>
              <li class="list-group-item">
                <div class="checkbox">
                  <input type="checkbox" id="4th-item" checked>
                  <label for="4th-item"><span>disabled Porta ac consectetur ac</span></label>
                </div>
              </li>
              <li class="list-group-item">
                <div class="checkbox">
                  <input type="checkbox" id="5th-item" checked>
                  <label for="5th-item"><span>Vestibulum at eros</span></label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </li>
  </ul>

  <!-- 2015 -->
  <ul class="timeline">
    <li class="timeline-line"></li>
    <li class="timeline-group">
      <h5><span class="badge badge-primary cursor-default">2015</span></h5>
    </li>
  </ul>
  <ul class="timeline">
    <li class="timeline-line tline-t-none"></li>
    <!-- /.timeline-line -->
    <li class="timeline-item center-block">
      <div class="timeline-card card shadow-z-1">
        <div class="card-header">
          <div class="text-center">
            <p class="mt-1">
              <i class="ft-grid font-large-1"></i>
            </p>
            <h4>Project Gallery</h4>
            <p class="text-muted">July 1, 2015</p>
            <p class="w-75 mx-auto">Candy canes tiramisu tootsie roll candy toffee icing. Sugar plum candy canes sweet roll chocolate bar. Caramels donut bonbon. Pudding sweet roll gingerbread.</p>
          </div>
        </div>
        <!-- Image grid -->
        <div class="card-content">
          <div class="card-body" itemscope itemtype="http://schema.org/ImageGallery">
            <div class="row">
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-21.jpg" itemprop="thumbnail" alt="Banner 1"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-22.jpg" itemprop="thumbnail" alt="Banner 2"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-23.jpg" itemprop="thumbnail" alt="Banner 3"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-24.jpg" itemprop="thumbnail" alt="Banner 4"/>
              </figure>
            </div>
            <div class="row">
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-25.jpg" itemprop="thumbnail" alt="Banner 5"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-26.jpg" itemprop="thumbnail" alt="Banner 6"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-27.jpg" itemprop="thumbnail" alt="Banner 7"/>
              </figure>
              <figure class="col-md-3 col-sm-6 col-12" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
                <img class="img-thumbnail img-fluid" src="assets/img/banner/banner-28.jpg" itemprop="thumbnail" alt="Banner 8"/>
              </figure>
            </div>
          </div>
          <!--/ Image grid -->
        </div>
        <!--/ PhotoSwipe -->
      </div>
    </li>
  </ul>
  <ul class="timeline">
    <li class="timeline-line mb-4"></li>
    <li class="timeline-group">
      <h5><span class="badge badge-primary cursor-default">Founded in 2013</span></h5>
    </li>
  </ul>
</section>
<!--Vertical Timeline Ends-->
